import React from 'react';
import {injectIntl} from "react-intl";

function StateAutosuggestField() {
  return '';
}

export default injectIntl(StateAutosuggestField);
